export default "__VITE_ASSET__Da8uc95r__"